import { Close } from '@rossum/ui/icons';
import {
  IconCustomExport,
  IconFiles,
  IconLayoutGrid,
  IconMessage2,
  IconNotification,
} from '@rossum/ui/icons/tabler';
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
} from '@rossum/ui/material';
import { useIntl } from 'react-intl';
import { boldText, linebreak } from '../../../../lib/formaterValues';

type Props = {
  onClose: () => void;
  dataCy?: string;
};

const tooltips = [
  {
    id: 'receive' as const,
    Icon: IconFiles,
  },
  {
    id: 'understand' as const,
    Icon: IconMessage2,
  },
  {
    id: 'act' as const,
    Icon: IconNotification,
  },
  {
    id: 'export' as const,
    Icon: IconCustomExport,
  },
];

export const IntroToExtensions = ({ onClose, dataCy }: Props) => {
  const intl = useIntl();

  return (
    <Card elevation={1} data-cy={dataCy}>
      <CardContent sx={{ padding: 2.5 }}>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box
                sx={{
                  borderRadius: '100%',
                  width: 32,
                  height: 32,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: t => t.palette.action.disabledBackground,
                }}
              >
                <SvgIcon color="primary">
                  <IconLayoutGrid />
                </SvgIcon>
              </Box>
              <Typography variant="subtitle2">
                {intl.formatMessage({
                  id: 'containers.settings.extensions.intro.title',
                })}
              </Typography>
            </Stack>
            <IconButton onClick={onClose} size="small">
              <Close
                fontSize="small"
                sx={{ color: t => t.palette.text.secondary }}
              />
            </IconButton>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary" sx={{ pr: 4 }}>
              {intl.formatMessage({
                id: 'containers.settings.extensions.intro.description',
              })}
            </Typography>
            <div>
              <Grid container spacing={1}>
                {tooltips.map(({ id, Icon }) => (
                  <Grid item xs={6} key={id}>
                    <Stack direction="row" spacing={1}>
                      <Tooltip
                        placement="top"
                        title={
                          intl.formatMessage(
                            {
                              id: `containers.settings.extensions.intro.${id}.tooltip`,
                            },
                            { bold: boldText, linebreak }
                          ) ?? ''
                        }
                      >
                        <SvgIcon fontSize="small" color="action">
                          <Icon />
                        </SvgIcon>
                      </Tooltip>
                      <Typography variant="body2">
                        {intl.formatMessage({
                          id: `containers.settings.extensions.intro.${id}`,
                        })}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </div>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
